import React, { Component } from 'react'
import Marquee from "react-fast-marquee";
export default class Markquee extends Component {
  render() {
    return (
      <div>
      <Marquee style={{color:"white"}} >
      A full stack developer is a software engineer who is skilled in both front-end and back-end web development. They are responsible for designing and building complete web applications, from the user interface and user experience on the front-end, to the server-side logic and database management on the back-end. Full stack developers are proficient in a range of programming languages, frameworks, and technologies, including HTML, CSS, JavaScript, Node.js, React, Angular, Python, Ruby on Rails, MySQL, MongoDB, and more. They are also adept at problem-solving, debugging, and working collaboratively with designers, project managers, and other developers. Overall, full stack developers are highly versatile and essential members of any web development team.
</Marquee>
      
      </div>
    )
  }
}
